'use client';
import { Link } from '@skin-seoul/design-system';
import { VerticalProductCardImage } from './VerticalProductCardImage';
import ProductCardInfoName from '../components/ProductCardInfoName';
import ProductCardInfoRating from '../components/ProductCardInfoRating';
import { ProductCardInfoPrice } from '../components/ProductCardInfoPrice';
import type { ProductCardProps } from '../ProductCard.types';
import { ProductCardProvider } from '../ProductCardContext';
import React from 'react';
import { VerticalProductCardContent } from './VerticalProductCardContent';
import ProductCardAddToCart from '../components/ProductCardAddToCart';

export const VerticalProductCard = ({
  children,
  theme,
  onClick,
  orientation = 'vertical',
  ...componentProps
}: ProductCardProps) => {
  return (
    <ProductCardProvider
      value={{
        ...componentProps,
        theme,
        orientation,
      }}
    >
      <Link
        unstyled
        display="flex"
        flexDirection="column"
        gap={4}
        width="100%"
        cursor="pointer"
        minWidth={0}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        {...componentProps}
      >
        <>{children}</>
      </Link>
    </ProductCardProvider>
  );
};

VerticalProductCard.Content = VerticalProductCardContent;
VerticalProductCard.Image = VerticalProductCardImage;
VerticalProductCard.AddToCart = ProductCardAddToCart;
VerticalProductCard.InfoName = ProductCardInfoName;
VerticalProductCard.InfoRating = ProductCardInfoRating;
VerticalProductCard.InfoPrice = ProductCardInfoPrice;
